import type { Fallacy } from "./types";
import { createStory } from "./types";

export const samplingBias: Fallacy = {
    id: "sampling-bias",
    name: "Sampling Bias",
    emoji: "🧪",
    category: "Manipulasi Statistik",
    description: "Mengambil kesimpulan dari **sampel yang tidak representatif** terhadap populasi yang digambarkan.",
    tldr: "Surveinya cuma di mall Jakarta, tapi klaimnya mewakili seluruh Indonesia.",
    detail: "Sampling Bias terjadi ketika sampel yang digunakan **tidak mewakili populasi** secara keseluruhan, sehingga kesimpulan menjadi **bias dan tidak bisa digeneralisasi**.\n\nContoh umum: polling di Twitter tentang kebijakan pemerintah hanya mencerminkan pendapat pengguna Twitter — yang cenderung lebih muda dan urban. Mengklaim hasilnya mewakili 'suara rakyat Indonesia' adalah sampling bias.\n\nBentuk-bentuk sampling bias: self-selection bias (hanya yang peduli mengisi survei), convenience sampling (sampel yang paling mudah dijangkau), dan undercoverage (kelompok tertentu tidak terwakili). Untuk menghindarinya, perhatikan bagaimana sampel dikumpulkan dan apakah setiap anggota populasi punya kesempatan sama untuk terpilih.",
    story: createStory("Sampling Bias", "🧪", {
      hook: {
        title: "\"87% rakyat Indonesia menolak!\"",
        body: "Kedengeran meyakinkan... sampai kamu tau respondennya cuma dari followers Twitter si pembuat survei.",
      },
      convo: {
        claim: "Produk ini terbukti ilmiah, **9 dari 10 wanita setuju** kulit mereka lebih cerah setelah pakai. Survei dari 10 ribu pengguna loh!",
        response: "Yang kecewa udah cabut dan gak ngisi survei. **Sampelnya cuma yang puas.**",
      },
      reveal: {
        body: "Sampelnya **gak mewakili populasi**. Kesimpulannya jadi bias dan gak bisa digeneralisasi ke semua orang.",
      },
      insight: {
        title: "Kenapa ini bahaya?",
        body: "Survei Twitter cuma nangkep suara pengguna Twitter — yang **cenderung muda dan urban**. Klaim \"suara rakyat\" dari situ? Itu **echo chamber**, bukan representasi.",
      },
      engagement: {
        title: "Paling sering nemu Sampling Bias di mana nih?",
        body: "Survei politik atau iklan skincare? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["hasty-generalization", "survivorship-bias", "ecological-fallacy", "cherry-picking"],
  };
